import { useTranslation } from 'react-i18next';
import { Icon, Page } from '@/components';
import { useParams } from 'react-router-dom';
import { ProjectDashboardLegend, ProjectDashboardPanel } from '@/views';
import { useGetProjectQuery } from '@/redux';
import { isNotStartedProjectStatus } from '@/core';

function _ProjectDashboardPage() {
  const { t } = useTranslation();
  const { id } = useParams<'id'>();
  const { data } = useGetProjectQuery({ id: id! });
  const title = data?.name ?? t('fetchFallbackTitle');
  const titleSecondary = t('projects.dashboard.title');
  const isNotStarted = isNotStartedProjectStatus(data?.status);

  return (
    <>
      <Page.Card
        title={title}
        subTitle={titleSecondary}
        icon={<Icon type="pie-chart" />}
        color="#1FB197"
        actions={<ProjectDashboardLegend />}
      >
        {data && !isNotStarted && (
          <ProjectDashboardPanel
            projectId={data.id}
            communityId={data.communityId}
          />
        )}
      </Page.Card>
    </>
  );
}

export const ProjectDashboardPage = _ProjectDashboardPage;
